import { createStageBetQuery, gqlwsInstance } from "./stake-api";

class StakeBet {
    constructor(game){
      this.queries = createStageBetQuery(game, {})
      this.data = {}
      this.responses = []
    }

   async bet(variables = {amount: 0, currency: "btc"}){
      try {
        let gqlClient = gqlwsInstance()

        if(this.queries.bet){
           let q = {... this.queries.bet}
           q.variables = { ... q.variables, ... variables}

           let result = await gqlClient.wsQuery(q)

           this.responses.push(result)
     
           if(result?.data != null){  
            for( const [key, data] of Object.entries(result.data)){
                this.data = data
            }    
           }

            return result
        }
      }
      catch(err){
        console.log("[error] StageBet fnc bet ")
        console.error(err)
      }

    }

   async next(variables = {}){
      try {
        let gqlClient = gqlwsInstance()

        if(this.queries.next){
           let q = {... this.queries.next}
           q.variables = { ... q.variables, ... variables}

            let result = await gqlClient.wsQuery(q)

           this.responses.push(result)
     
          if(result.data != null){  
            for( const [key, data] of Object.entries(result.data)){
                this.data = data
            }    
          }

            return result
        }
      }
      catch(err){
        console.log("[error] StageBet fnc next ")
        console.error(err)
      }

    }

   async cashout(variables = {}){
      try {
        let gqlClient = gqlwsInstance()
        if(this.queries.cashout){
           let q = {... this.queries.cashout}
           q.variables = { ... q.variables, ... variables}

           let result = await gqlClient.wsQuery(q)

           this.responses.push(result)
           
            if(result.data != null){  
              for( const [key, data] of Object.entries(result.data)){
                  this.data = data
              }    
            }

            return result
        }
      }
      catch(err){
        console.log("[error] StageBet fnc cashout ")
        console.error(err)
      }

    }
}

export { StakeBet }



class HiloBet extends StakeBet{
  constructor(variables, gqlClient){
    super('hilo', variables,gqlClient)

    this.betData
    this.nSteps = 0
  }

  async next(guess){
    const HiloGuess = ["lower","lowerEqual","equal","higherEqual","higher"]

    if(!HiloGuess.includes(guess))
      return [{error: "invalid guess parameter. guess has to be one of ["+HiloGuess.join(", ")+"]"} , null ]

    let [err, result] = await this.step("next", {guess: guess})

    if(err)
      return [err, null]

    if(result.hiloNext)
      this.betData = {... this.betData, ... result.hiloNext}


    if(!this.betData.active)
     this.done(this.betData)

    return [err, this.betData]
  }

  async bet(card="HA", amount, currency){
    card = card.split("")
    let startCard = { suit: card[0], rank: card[1] }
    let [err, result] = await this.step("bet", {amount: amount, currency: currency, startCard: startCard })

    if(err)
      return [err, null]

    if(result.hiloBet)
      this.betData = {... this.betData, ... result.hiloBet}

    return [null, this.betData]
  }

  async cashout(){ 
    let [err, result] = await this.step("cashout")

    if(err)
      return [err, null]
  

     if(result.hiloCashout)
      this.betData = {... this.betData, ... result.hiloCashout}


    if(!this.betData.active)
        this.done(this.betData)

    
     return [null, this.betData ]
  }

  async step(action, variables = {}){
    try {
       
      if(super[action] && typeof super[action] === "function"){
        let step_result = await super[action](variables)

        this.nSteps++

        if (step_result.errors)
          return [step_result.errors, null]
        else
          return [null, step_result.data]
      }

    }
    catch(err){
      console.log("[err] HiloBet fnc step: ")
      console.error(err)
      return [err, null]
    }
   
  }

  done(betResult){
    if(this._resultResolve)
      this._resultResolve(betResult)
  }

  result(){
    return new Promise((resolve,reject) =>{
      this._resultResolve = resolve
      this._resultReject = reject

    })
  }
}

export { HiloBet }


/*

hiloBet.step("bet", {amount: 0, currency: "eth", startCard: { suit: "H",  rank: "7" } } ).then( ([err,result]) =>{ console.log(err,result)})

*/




/*
var a = [1,2,3,1,2,3,4];

var initialHand = [
    {
        "suit": "S",
        "rank": "4"
    },
    {
        "suit": "H",
        "rank": "9"
    },
    {
        "suit": "H",
        "rank": "4"
    },
    {
        "suit": "C",
        "rank": "A"
    },
    {
        "suit": "D",
        "rank": "4"
    }
]
var map_byRank = initialHand.reduce(function(obj, b) {
  console.log("el: ", b)
  if(!obj[b.rank])
    obj[b.rank] = {count: 0, list: []}
    
  obj[b.rank].count = ++obj[b.rank].count || 1;
  obj[b.rank].list.push(b)
  return obj;
}, {});

//console.log("map_byRank: ", map_byRank, "---------");

var map_bySuits = initialHand.reduce(function(obj, b) {
  if(!obj[b.suit])
    obj[b.suit] = {count: 0, list: []}
    
  obj[b.suit].count = ++obj[b.suit].count || 1;
  obj[b.suit].list.push(b)
  return obj;
}, {});

//console.log("map_bySuits: ", map_bySuits);




*/